import * as actionTypes from "../actionTypes";

const initialState = {
  activeOrders: [],
  readyToSendOrders: [],
  rejectedOrders: [],
  active_ready_length: { active: 0, ready: 0 },
  ordersHistory: { data: [], filtered: 0, total_qtty: 0 },
  subOrders: [],
  transactions: [],
  qrCode: null,
  currentOrder: "",
  qrLoad: true,
  Load_Downoad: {
    all: false,
    single: false,
  },
  message: "",
};

export const OrderReducer = (state = initialState, action) => {
  let ret = "";

  switch (action.type) {
    case actionTypes.ACTIVE_ORDERS:
      ret = "activeOrders";
      break;
    case actionTypes.CURRENT_ORDER:
      ret = "currentOrder";
      break;
    case actionTypes.ORDERS_HISTORY:
      ret = "ordersHistory";
      break;
    case actionTypes.SUB_ORDERS:
      ret = "subOrders";
      break;
    case actionTypes.READY_TO_SEND:
      ret = "readyToSendOrders";
      break;
    case actionTypes.MESSAGES:
      ret = "popupMessages";
      break;
    case actionTypes.MODAL_LOADING:
      ret = "modal_loading";
      break;
    case actionTypes.QRCODE:
      ret = "qrCode";
      break;
    case actionTypes.LOADING:
      ret = "loading";
      break;
    case actionTypes.REFRESH:
      ret = "refresh";
      break;
    case actionTypes.LET_REFRESH:
      ret = "letRefresh";
      break;
    case actionTypes.QR_LOAD:
      ret = "qrLoad";
      break;
    case actionTypes.LOAD_DOWNLOAD:
      ret = "Load_Downoad";
      break;
    case actionTypes.MESSAGE:
      ret = "message";
      break;
    case actionTypes.REJECTED_ORDER:
      ret = "rejectedOrders";
      break;
    case actionTypes.SET_ORDERS_LENGTH:
      ret = "active_ready_length";
      break;

    default:
      return state;
  }
  return { ...state, [ret]: action.payload };
};
